import { FieldInputProps } from "react-final-form";
import { useDispatch } from "react-redux";

import { FileUpload } from "@livechat/design-system-icons";
import { Button, Icon } from "@livechat/design-system-react-components";

import { FilePicker } from "components/form/FilePicker";
import { ToastContent, getToastContent } from "constants/toasts";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { useLogoUpload } from "hooks/use-logo-upload";
import { ToastVariant, ToastsActions } from "store/features/toasts";

interface IProps {
  templateID?: string;
  input: FieldInputProps<string | boolean, HTMLElement>;
  setTransactionID: (transactionId: string) => void;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const LogoUploadField = ({ templateID, input, setTransactionID }: IProps) => {
  const { mutate: uploadLogo } = useLogoUpload(setTransactionID);
  const dispatch = useDispatch();
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  const handleFilePickError = (error: any) => {
    dispatch(
      ToastsActions.createToast({
        variant: ToastVariant.Error,
        content: getToastContent(ToastContent.LOGO_UPLOAD_FAILURE, {
          type: error.type,
        }),
      })
    );
  };
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  const handleFilePickSuccess = (file: any) => {
    uploadLogo(
      { file, templateID },
      {
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onSuccess: (url: any) => {
          input.onChange(url);
          dispatch(
            ToastsActions.createToast({
              variant: ToastVariant.Success,
              content: getToastContent(ToastContent.LOGO_UPLOAD_SUCCESS),
            })
          );
          trackEngagement("Visual template editor: Appearance logo upload uploaded", EventPlace.Settings);
        },
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error: any) => {
          handleFilePickError(error);
        },
      }
    );
  };

  return (
    <FilePicker
      onChange={handleFilePickSuccess}
      onError={handleFilePickError}
      extensions={["png", "jpg", "jpeg"]}
      maxSizeInMB={1}
      dataTestId="filepicker-UploadLogo"
    >
      <Button type="button" kind="plain" icon={<Icon source={FileUpload} />} data-testid="button-UploadLogo">
        Upload file
      </Button>
    </FilePicker>
  );
};
